export class Snippet {

  /**
   * @type {string}
   */
  #appName;

  /**
   * @type {string}
   */
  shopHash = '';

  /**
   * @type {int}
   */
  productId;

  /**
   * @type {int}
   */
  productPrice;

  /**
   * @type {*[]}
   */
  productCollections = [];

  /**
   * @param {string} appName
   */
  constructor(appName) {
    this.#appName = appName;
    this.fillFromSource();
  }

  /**
   *
   */
  fillFromSource() {
    const isSnippetSet = (
      typeof (Spurit) !== 'undefined'
      && typeof (Spurit[this.#appName]) !== 'undefined'
      && typeof (Spurit[this.#appName].snippet) !== 'undefined'
    );
    if (isSnippetSet) {
      const { snippet } = Spurit[this.#appName];
      for (const key in snippet) {
        if ({}.hasOwnProperty.call(snippet, key)) {
          this[key] = snippet[key];
        }
      }
    }
  }
}